export interface IDiagnostics {
  sendException(error: any, additionalParams?: any): Promise<boolean>;
  transformError(error: any): Promise<any>;
  log(e: any, text: string, ...optionalParams: any[]): void;
}

const DefaultDiagnostics: IDiagnostics = {
  sendException(error: any, additionalParams?: any): Promise<boolean> {
    console.error("[D]", error, additionalParams);
    return Promise.resolve(true);
  },
  log(e: any, text: string, ...optionalParams: any[]): void {
    console.log("[D]", ...[e, e?.stack, text, ...optionalParams])
  },
  transformError(error: any): Promise<any> {
    return Promise.resolve(error);
  }
}

export let Diagnostics = DefaultDiagnostics;

export function setDiagnostics(diagnostics: IDiagnostics): void {
  Diagnostics = diagnostics;
}

export function reloadWindow(): void {
  console.warn("window.location.reload!");
  window.location.reload();
}